'use client';

import Image from "next/image";
import { useRouter } from "next/navigation";
import { useState, useEffect, useRef } from "react";
import { HiHome } from "react-icons/hi2";

const Logo = () => {
  const router = useRouter();
  const [contextMenu, setContextMenu] = useState<{ x: number; y: number } | null>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const logoRef = useRef<HTMLDivElement>(null);

  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
    setContextMenu({ x: e.clientX, y: e.clientY });
  };

  const handleOpenInNewTab = () => {
    window.open('/', '_blank');
    setContextMenu(null);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target as Node) &&
        logoRef.current &&
        !logoRef.current.contains(event.target as Node)
      ) {
        setContextMenu(null);
      }
    };

    if (contextMenu) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [contextMenu]);

  return (
    <>
      <div ref={logoRef} onContextMenu={handleContextMenu}>
        {/* Imagen para dispositivos pequeños */}
        <Image
          onClick={() => router.push('/')}
          className="block md:hidden cursor-pointer"
          src="/images/be-underwater-text-3.png"
          height={120}
          width={120}
          alt="Logo Small"
        />
        {/* Imagen para dispositivos grandes */}
        <Image
          onClick={() => router.push('/')}
          className="hidden md:block cursor-pointer"
          src="/images/be-underwater-logo-7.png"
          height={80}
          width={80}
          alt="Logo Large"
        />
      </div>

      {/* Menú contextual */}
      {contextMenu && (
        <div
          ref={menuRef}
          className="fixed z-50 bg-white rounded-lg shadow-lg border border-gray-200 py-1 min-w-[180px]"
          style={{
            left: `${contextMenu.x}px`,
            top: `${contextMenu.y}px`,
          }}
        >
          <button
            onClick={handleOpenInNewTab}
            className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2 transition-colors"
          >
            <HiHome size={18} />
            <span>Open in new tab</span>
          </button>
        </div>
      )}
    </>
  );
}

export default Logo;
